import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { globalErrorHandler } from '@ca/core/services';
import { TranslateModule } from '@ngx-translate/core';
import { SidebarModule } from 'ng-sidebar-v3';
import { CoreSharedModule } from '../shared-modules/core-shared/core-shared.module';
import { NotificationsSharedModule } from '../shared-modules/notifications-shared/notifications-shared.module';
import { SharedModule } from '../shared/shared.module';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ExperimentalFeaturesComponent } from './components/experimental-features/experimental-features.component';
import { FeedbackButtonComponent } from './components/feedback-button/feedback-button.component';
import { FooterLandingComponent } from './components/footer-landing/footer-landing.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';
import { PermissionDeniedComponent } from './components/permission-denied/permission-denied.component';
import { SidebarMobileLoggedOutNavComponent } from './components/sidebar-nav/sidebar-mobile-logged-out-nav/sidebar-mobile-logged-out-nav.component';
import { SidebarNavHeaderComponent } from './components/sidebar-nav/sidebar-nav-header/sidebar-nav-header.component';
import { SidebarNavLinkComponent } from './components/sidebar-nav/sidebar-nav-link/sidebar-nav-link.component';
import { SidebarNavComponent } from './components/sidebar-nav/sidebar-nav.component';
import { INTERCEPTORS } from './interceptors/interceptors';
import { AriApplicationService } from './services/ari-application.service';
import { SupportService } from './services/customer-support.service';
import { FileService } from './services/file.service';
import { ModuleCategoriesV1Service } from './services/module-categories-v1.service';
import { ModuleSharingService } from './services/module-sharing.service';
import { ModuleSubmissionAdminService } from './services/module-submission-admin.service';
import { ModuleVersionService } from './services/module-version.service';
import { ModulesAdminV1Service } from './services/modules-admin-v1.service';
import { ModulesPublicServiceV1 } from './services/modules-public-v1.service';
import { ModulesWorkspaceV1Service } from './services/modules-workspace-v1.service';
import { RepositoryService } from './services/repository-service/repository.service';
import { ResultsService } from './services/results/results.service';
import { RoutingStateService } from './services/routing-state.service';
import { SignalrService } from './services/signalr.service';
import { UserWorkspaceService } from './services/user-workspace.service';
import { WorkflowCategoriesV1Service } from './services/workflow-categories-v1.service';
import { WorkflowRunQueueService } from './services/workflow-run-queue.service';
import { WorkflowSubmissionService } from './services/workflow-submission.service';
import { WorkflowV1Service } from './services/workflow-v1.service';

@NgModule({
    imports: [RouterModule, SharedModule, CoreSharedModule, SidebarModule.forRoot(), TranslateModule, NotificationsSharedModule],
    declarations: [
        BreadcrumbComponent,
        ExperimentalFeaturesComponent,
        FeedbackButtonComponent,
        FooterComponent,
        FooterLandingComponent,
        HeaderComponent,
        MaintenanceComponent,
        PermissionDeniedComponent,
        SidebarMobileLoggedOutNavComponent,
        SidebarNavComponent,
        SidebarNavHeaderComponent,
        SidebarNavLinkComponent,
        MaintenanceComponent,
    ],
    providers: [
        INTERCEPTORS,
        globalErrorHandler,
        FileService,
        ModuleCategoriesV1Service,
        ModulesAdminV1Service,
        ModuleSharingService,
        ModulesPublicServiceV1,
        ModuleSubmissionAdminService,
        ModulesWorkspaceV1Service,
        ModuleVersionService,
        RepositoryService,
        ResultsService,
        RoutingStateService,
        SignalrService,
        SupportService,
        UserWorkspaceService,
        WorkflowCategoriesV1Service,
        WorkflowRunQueueService,
        WorkflowSubmissionService,
        WorkflowV1Service,
        AriApplicationService,
    ],
    exports: [FooterComponent, FooterLandingComponent, HeaderComponent, SidebarModule, SidebarNavComponent, PermissionDeniedComponent, FeedbackButtonComponent],
})
export class CoreModule {}
